import { useQuery } from '@tanstack/vue-query'
import { TEN_MINUTES_MS } from '@shared/utils'
import { transactionKeys } from '../transactionQueryKeys'
import { getTransactionsFilters } from '../transactionEndpoints'

export function useTransactionsFiltersQuery() {
  return useQuery({
    queryKey: transactionKeys.filters(),
    queryFn: getTransactionsFilters,
    staleTime: TEN_MINUTES_MS,
  })
}
